// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3aDYb","footer":"ModalInfo_footer__2yySy"};